import { common, container } from '@mtfe/sweet-utils';
import { addGeoError, GeoSource } from '@mtfe/sweet-report';

import guidFactory from './guidFactory';
import GEO from './GEO';

const { isInDianPingApp, isInTuanApp, isInWaiMaiApp, isMiniProgramTuan, isMiniProgramWaimai, isMiniProgramDianping, isMiniProgram, isInWeixin } = container;
const { qsParse } = common;


let _rootPvId; // 用于数据打通关联，query获取
let _frontEndParams; // 前端需要的参数，不透传给后端
let _frontCardParams; // 前卡参数
let _s; // 来源渠道
let _um; // utm_medium
let _rest; // 其他url query

let hasReportedGeoError = false;

// 自执行解析url query
(() => {
    const queryInSearch = qsParse(window.location.search.slice(1));
    const queryInHash = qsParse(window.location.hash.replace(/^[^\?]*/, '').replace(/^\?/, ''));
    const query = { ...queryInSearch, ...queryInHash };
    const { rootPvId, front_end_params, front_card_params, s, um, ...rest } = query;// front_end_params front_card_params结构出来，不传给后端。前端使用时，从parseAdParams中获取

    _rootPvId = rootPvId || guidFactory.getRootvId();
    _frontEndParams = front_end_params;
    _frontCardParams = front_card_params;
    _s = s;
    _um = um;
    _rest = rest;
})();

const getOadParams = async (contentPvId = '', needFrontLbs = true) => {
    // 处理LBS参数
    const lbsObj = {};
    if (needFrontLbs) {
        // 小程序获取位置 -- 获取失败时为空串
        const geo = await GEO.getLatLon();
        if (geo == null && !hasReportedGeoError) {
            // 这里需要控制上报次数，只有在第一次定位获取不到时上报，不然每次检索都会进行未获取位置信息的上报
            addGeoError(GeoSource.all, '定位结果异常:未获取到定位信息');
            hasReportedGeoError = true;
        } else {
            Object.assign(lbsObj, geo);
        }
    }

    // 定义参考文档： https://km.sankuai.com/page/1085396521#id-%E4%B8%80%E3%80%81adParams
    return Object.assign(
        {},
        {
            s: _s,
            um: _um,
            ...lbsObj,
            mediumParams: Object.assign({}, _rest),
            appContainer: isInDianPingApp
                ? 'DIAN_PING_APP'
                : isInTuanApp
                    ? 'MEI_TUAN_APP'
                    : isInWaiMaiApp
                        ? 'WAI_MAI_APP'
                        : isMiniProgramDianping
                            ? 'WEI_XIN_DIANPING_MINI_PROGRAM'
                            : isMiniProgramTuan
                                ? 'WEI_XIN_TUAN_MINI_PROGRAM'
                                : isMiniProgramWaimai
                                    ? 'WEI_XIN_WAIMAI_MINI_PROGRAM'
                                    : isMiniProgram
                                        ? 'WEI_XIN_MINI_PROGRAM'
                                        : isInWeixin
                                            ? 'WEI_XIN_APP'
                                            : 'UNKNOW',
            rootPvId: _rootPvId,
            pagePvId: guidFactory.getPagePvId(),
            pageSessionId: guidFactory.getPageSessionId(),
            outerPvId: '',// outerPvId原方案从handleCookie中获取，由于handleCookie废弃，该字段未使用，仅保留扩展。
            contentPvId,
        },
    );
};

export { getOadParams };
